import React from 'react'

const Logo = () => (
  <div className="row">
    <div className="col">
      <div className="logo">
        <i className="fa fa-code" />
        <span className="title">Sigma</span>
      </div>
    </div>
  </div>
)
export default Logo



// WEBPACK FOOTER //
// ./src/pages/home/Logo.js